module.exports = __webpack_public_path__ + "media/flags/lv-b54b0a57.svg";